import { createSharedSelector } from 'core/utils/selectorHelpers'
import getDataSelector from 'core/utils/getDataSelector'
import DataKeys from 'k8s/DataKeys'

export const ssoAttributesSelector = createSharedSelector(
  getDataSelector<DataKeys.SsoAttributes>(DataKeys.SsoAttributes),
  (response) => {
    return response.map((item) => {
      return {
        ...item,
        attributeKeys: Object.values(item?.attributes || {}),
      }
    })
  },
)
